import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/links/PhoneLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/WhatsappWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/navigation/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/navigation/NavLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/providers/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/fonts.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\",\"preload\":true,\"fallback\":[\"-apple-system\",\"BlinkMacSystemFont\",\"Segoe UI\",\"Roboto\",\"system-ui\",\"sans-serif\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/fonts.ts\",\"import\":\"Urbanist\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-urbanist\",\"display\":\"swap\",\"preload\":true,\"fallback\":[\"-apple-system\",\"BlinkMacSystemFont\",\"Segoe UI\",\"Roboto\",\"system-ui\",\"sans-serif\"]}],\"variableName\":\"urbanist\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/homes-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/innovation-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/jobs-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/ravo-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/white-logo.png");
